import React, { useEffect } from "react";
import { getShortUrlData } from "../../../services/authAPI";
import { getLoginData } from "../../../utility/AppStoreData";
import * as Linking from "expo-linking";
import { encode } from "js-base64";
import RedirectLoader from "../../../Components/RedirectLoader";

/**
 * Handles simple short URLs: /ko/:shortCode
 * These are 6-character alphanumeric codes that map to full URLs
 */
export default function SimpleShortUrlRedirectScreen({ route, navigation }) {
    useEffect(() => {
        // Set proper page title
        if (typeof document !== "undefined") {
            document.title = "Redirecting... | Kallout";
        }
        handleRedirect();
    }, []);

    const handleRedirect = async () => {
        try {
            const params = route.params || {};
            const shortCode = params.shortCode || "";

            console.log("SimpleShortUrlRedirectScreen - shortCode:", shortCode);

            if (!shortCode) {
                console.error("No shortCode found in URL");
                navigation.replace("DrawerRoute", { screen: "HomeTabStack" });
                return;
            }

            // Call API to resolve short URL
            console.log(`Calling API: getShortUrlData(shortCode="${shortCode}")`);
            const response = await getShortUrlData(shortCode, null);
            console.log("API Response:", response);

            // Handle new ShortUrls format (source: "ShortUrls")
            const fullUrl = response?.fullUrl || response?.shareableUrl?.fullUrl;

            if (fullUrl) {
                let redirectUrl = fullUrl;

                // Check if user is logged in
                const loginData = await getLoginData();
                const isLoggedIn = loginData !== null;

                console.log("User login status:", isLoggedIn ? "Logged in" : "Not logged in");

                // Only append invite parameter if user is NOT logged in
                if (!isLoggedIn && response.referralTracking) {
                    const inviteParams = encode(
                        JSON.stringify({
                            referralCode: response.referralTracking.referralCode,
                            directReferrerId: response.referralTracking.directReferrerId,
                        })
                    );

                    // Append invite parameter to the URL
                    const separator = redirectUrl.includes("?") ? "&" : "?";
                    redirectUrl = `${redirectUrl}${separator}invite=${inviteParams}`;

                    console.log("Appended referral data to URL (user not logged in)");
                }

                console.log("Redirecting to:", redirectUrl);

                // Redirect to the full URL
                if (typeof window !== "undefined") {
                    window.location.href = redirectUrl;
                } else {
                    await Linking.openURL(redirectUrl);
                }
            } else {
                console.error("No fullUrl found in response");
                navigation.replace("DrawerRoute", { screen: "HomeTabStack" });
            }
        } catch (error) {
            console.error("Error in SimpleShortUrlRedirectScreen:", error);
            navigation.replace("DrawerRoute", { screen: "HomeTabStack" });
        }
    };

    return <RedirectLoader />;
}
